import { Dispatch } from 'redux'

import {
  getSimFlawAggregates,
  getSimFlawGroups,
  getSimFlawSettings
} from 'redux/api/internal/SimFlaws'
import { TGetSimFlawGroupsQueryParams } from 'redux/api/internal/SimFlaws/contract'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

/**
 * The reducer's scope guard compares this, not the params object: two
 * requests are the same request only when every filter and both windows
 * match.
 */
export function simFlawGroupsRequestKey(
  params: TGetSimFlawGroupsQueryParams
): string {
  return [
    params.customer_id ?? 'all',
    params.table_name ?? 'all',
    params.type ?? 'all',
    params.offset ?? '0',
    params.limit ?? 'default',
    params.rows_offset ?? '0',
    params.rows_limit ?? 'default'
  ].join('|')
}

export function tryGetSimFlawGroups(params: TGetSimFlawGroupsQueryParams = {}) {
  return (dispatch: Dispatch) => {
    const requestKey = simFlawGroupsRequestKey(params)

    dispatch(actions.getGroups({ requestKey }))

    getSimFlawGroups(params)
      .then((response) => {
        dispatch(
          actions.getGroupsSuccess({ data: response.data.data, requestKey })
        )
      })
      .catch(() => {
        dispatch(actions.getGroupsFailed({ requestKey }))
      })
  }
}

export function tryGetSimFlawAggregates(customerId?: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAggregates({ customerId }))

    getSimFlawAggregates(customerId)
      .then((response) => {
        dispatch(
          actions.getAggregatesSuccess({
            customerId,
            data: response.data.data
          })
        )
      })
      .catch(() => {
        dispatch(actions.getAggregatesFailed({ customerId }))
      })
  }
}

export function tryGetFlawSettings() {
  return (dispatch: Dispatch) => {
    getSimFlawSettings()
      .then((response) => {
        dispatch(actions.getSettingsSuccess({ data: response.data.data }))
      })
      .catch(() => {
        // The labels are cosmetic - the page falls back to the raw table and
        // attribute names, so there is nothing to put in the store on failure.
      })
  }
}

export const useSimFlawActions = () => {
  return {
    tryGetFlawSettings: useThunkActions(tryGetFlawSettings),
    tryGetSimFlawAggregates: useThunkActions(tryGetSimFlawAggregates),
    tryGetSimFlawGroups: useThunkActions(tryGetSimFlawGroups)
  }
}
